/**
 * Created by carlhaynes on 9/28/17.
 */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ArtistItem from "./ArtistItem";

class ArtistList extends Component {

  // componentWillMount() {
  //   console.log("CollectorList componentWillMount");
  //   console.log("length: " + this.props.collectors.length);
  // }

  render() {
    return (
      <div>
        hello {this.props.artists.length}
        <p/>
        {this.props.artists.map(function(artistValue){
          return <ArtistItem key={artistValue.uid} artist={artistValue}/>
        })}
      </div>
    );
  }
}

ArtistList.propTypes = {
  artists: PropTypes.array.isRequired
};

export default ArtistList;



// WEBPACK FOOTER //
// ./src/Components/ArtistList.jsx